import decode from 'jwt-decode';

export default class AuthService {
  constructor() {
    this.loggedIn = this.loggedIn.bind(this);
    this.isTokenExpired = this.isTokenExpired.bind(this);
    this.setToken = this.setToken.bind(this);
    this.unsetToken = this.unsetToken.bind(this);
    this.getToken = this.getToken.bind(this);
    this.getUserId = this.getUserId.bind(this);
  }

  loggedIn() {
    const token = this.getToken();
    return !!token && !this.isTokenExpired(token);
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token);
      return decoded.exp < Date.now() / 1000;
    } catch (err) {
      return false;
    }
  }

  appendBearerToToken = (token = '') => {
    const tokenSplits = token.split(' ');
    if (tokenSplits.length === 2 && tokenSplits[0].toLowerCase() === 'bearer') {
      return token;
    }

    return `Bearer ${token}`;
  };

  setToken(idToken) {
    const token = this.appendBearerToToken(idToken);
    return localStorage.setItem('token', token);
  }

  unsetToken() {
    return localStorage.removeItem('token');
  }

  getToken() {
    return localStorage.getItem('token');
  }

  getUserId() {
    const token = decode(this.getToken());
    return token.id;
  }
}
